/**
 * Brand constants — client side.
 *
 * Mirrors server/config/brand.js. The Google review URL lives here because it
 * had drifted into several hardcoded copies with conflicting values. Import it
 * rather than pasting the URL into a component.
 *
 * VERIFIED VALUE: confirmed by Thomas from his Google Business Profile,
 * 23 Jul 2026. Keep in sync with server/config/brand.js.
 */

export const GOOGLE_REVIEW_URL = 'https://g.page/r/CccGyOWKUavWEBM/review';

export const BUSINESS = {
  name: 'Utah Realty Photos',
  phone: '(801) 210-0281',
  email: 'info@utahrealtyphotos.com',
  site: 'https://www.utahrealtyphotos.com',
  googleReviewUrl: GOOGLE_REVIEW_URL
};

export default BUSINESS;
